import clsx from 'clsx'
import React from 'react'
import useStyles from './styles'

interface Props {
  isSelected: boolean
  content: string
  onClick: () => void
}

export const SelectableTile = ({ content, isSelected, onClick, ...rest }: Props) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, { [classes.selected]: isSelected })} onClick={onClick} {...rest}>
      {content}
    </div>
  )
}
